import { useCallback, useState } from "react";
import type { TaskItem } from "@edge/shared";
import { fetchCompletedPersonalTasks } from "../api";

export interface CompletedTasksState {
  tasks: TaskItem[];
  loading: boolean;
  error: string | null;
  load: (q?: string) => Promise<void>;
  clear: () => void;
}

/**
 * Lazy-loaded completed-task history. Only fetches when load() is called —
 * which the TasksRail does the first time the user toggles "show completed".
 */
export function useCompletedTasks(): CompletedTasksState {
  const [tasks, setTasks] = useState<TaskItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async (q?: string) => {
    setLoading(true);
    try {
      const rows = await fetchCompletedPersonalTasks(q);
      setTasks(rows);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "fetch_failed");
    } finally {
      setLoading(false);
    }
  }, []);

  const clear = useCallback(() => setTasks([]), []);

  return { tasks, loading, error, load, clear };
}
